export default {
  PANELS: {
    DELETE_FOLDER: 'components/ImageManagerDialogs/DeleteFolderDialogWrapper',
    RENAME_FOLDER: 'components/ImageManagerDialogs/RenameFolderDialogWrapper',
    NEW_FOLDER: 'components/ImageManagerDialogs/NewFolderDialogWrapper',
    DELETE_IMAGE: 'components/ImageManagerDialogs/DeleteImageDialogWrapper',
    RENAME_IMAGE: 'components/ImageManagerDialogs/EditInfoImageDialogWrapper',
    ERROR_IMAGE: 'components/ImageManagerDialogs/ErrorImageDialogWrapper',
  }
};
